import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular'
import { ICellRendererParams } from 'ag-grid-community';

interface IconCellRendererParams extends ICellRendererParams {
  icon: string;
  color: string;
}

@Component({
  selector: 'app-icon-cell-renderer',
  template: ` <span [style.color]="params.color">
    <i [class]="params.icon"></i>
  </span> `

})
export class IconCellRendererComponent implements ICellRendererAngularComp {

  public params!: IconCellRendererParams;

  // take the values passed in the params, if no value is passed, set to blank
  agInit(params: IconCellRendererParams): void {
    this.params = params
    if (this.params.value == false || this.params.value == null || this.params.value == 'no') {
      this.params.icon = ''
      this.params.color = ''
    }
  }

  refresh(params: IconCellRendererParams): boolean {
    this.params = params;
    return false;
  }

}
